import React from 'react';
import Input from './../../input';
import Color from './../../color_input';

import createReactClass from 'create-react-class';
export default createReactClass({
  displayName: 'SignControls',

  render: function() {
    return (
      <div className="customization-controls">
        <Color
          label="Background color"
          name="background_color"
          defaultValue={this.props.background_color}
          onChange={this.props.onChange.bind(null, 'background_color')}
        />
        <Color
          label="Primary text color"
          name="primary_text_color"
          defaultValue={this.props.primary_text_color}
          onChange={this.props.onChange.bind(null, 'primary_text_color')}
        />
        <Color
          label="Secondary text color"
          name="secondary_text_color"
          defaultValue={this.props.secondary_text_color}
          onChange={this.props.onChange.bind(null, 'secondary_text_color')}
        />
        <Color
          label="Sign frame color"
          name="sign_frame_color"
          defaultValue={this.props.sign_frame_color}
          onChange={this.props.onChange.bind(null, 'sign_frame_color')}
        />
        <Color
          label="Sign text color"
          name="sign_text_color"
          defaultValue={this.props.sign_text_color}
          onChange={this.props.onChange.bind(null, 'sign_text_color')}
        />
        <Color
          label="Sign background color"
          name="sign_background_color"
          defaultValue={this.props.sign_background_color}
          onChange={this.props.onChange.bind(null, 'sign_background_color')}
        />
        <Color
          label="Button color"
          name="button_color"
          type="text"
          defaultValue={this.props.button_color}
          onChange={this.props.onChange.bind(null, 'button_color')}
        />
      </div>
    );
  },
});
